import { render, staticRenderFns } from "./OrderModuleSetup.vue?vue&type=template&id=3e8a1c73&scoped=true"
import script from "./OrderModuleSetup.vue?vue&type=script&lang=js"
export * from "./OrderModuleSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8a1c73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8a1c73')) {
      api.createRecord('3e8a1c73', component.options)
    } else {
      api.reload('3e8a1c73', component.options)
    }
    module.hot.accept("./OrderModuleSetup.vue?vue&type=template&id=3e8a1c73&scoped=true", function () {
      api.rerender('3e8a1c73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/OrderModuleSetup.vue"
export default component.exports